import { Box } from 'mds-web-ui'
import * as Select from '@radix-ui/react-select'
import { navigate } from 'gatsby'
import React from 'react'
import { ChevronDown } from 'react-feather'
import styled from 'styled-components'
import { border, color, layout, space, typography } from 'styled-system'

import { fontSizes } from '../utils/Typography'

const CATEGORY_ALL = 'all'
const GALLERY_BASE_URL = '/flow/gallery/'

export const CategorySelect = ({ categories, category, ...props }) => {
  return (
    <Select.Root
      onValueChange={value => {
        if (value === CATEGORY_ALL) {
          navigate(GALLERY_BASE_URL)
          return
        }

        navigate(`${GALLERY_BASE_URL}${value}`)
      }}
    >
      <StyledTrigger
        aria-label="Category"
        fontSize={fontSizes.body}
        pl={3}
        pr={2}
        py={1}
        {...props}
      >
        <Select.Value placeholder={category || CATEGORY_ALL} />
        <Select.Icon>
          <Box pt="2px">
            <ChevronDown size={24} color="#9ba1a6" />
          </Box>
        </Select.Icon>
      </StyledTrigger>
      <Select.Portal>
        <StyledContent>
          <StyledViewport>
            <SelectItem value={CATEGORY_ALL}>{CATEGORY_ALL}</SelectItem>

            {categories.map(({ label }) => {
              return (
                <SelectItem key={`category--${label}`} value={label}>
                  {label}
                </SelectItem>
              )
            })}
          </StyledViewport>
        </StyledContent>
      </Select.Portal>
    </Select.Root>
  )
}

const SelectItem = ({ children, ...props }) => {
  return (
    <StyledSelectItem fontSize={fontSizes.body} {...props}>
      <Select.ItemText>{children}</Select.ItemText>
    </StyledSelectItem>
  )
}

const StyledTrigger = styled(Select.Trigger)(
  {
    display: 'flex',
    flex: 'none',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 4,
    textTransform: 'capitalize',
    backgroundColor: 'transparent',
    color: '#3a3f42',
    boxShadow: '0 0 0 1px #e5e7e8',
    border: 'none',
    borderRadius: 6,
    lineHeight: 1,
    height: 38,
    minWidth: 150,
    '&:hover': {
      cursor: 'pointer',
      color: '#000',
      boxShadow: '0 0 0 2px #e5e7e8',
      svg: {
        stroke: '#3a3f42'
      }
    },
    '&:focus': {
      boxShadow: '0 0 0 2px #000'
    }
  },
  layout,
  space,
  color,
  border,
  typography
)

const StyledSelectItem = styled(Select.Item)(
  {
    textTransform: 'capitalize',
    lineHeight: 1,
    color: '#3a3f42',
    borderRadius: 3,
    display: 'flex',
    alignItems: 'center',
    height: 38,
    padding: '0 25px 0 25px',
    position: 'relative',
    userSelect: 'none',
    fontFamily: 'sans-serif',
    minWidth: 155,
    transition: 'background-color 90ms ease-out',
    '&[data-highlighted]': {
      cursor: 'pointer',
      outline: 'none',
      backgroundColor: 'rgba(42, 69, 76, 0.08)',
      color: '#000'
    }
  },
  typography
)

const StyledContent = styled(Select.Content)({
  overflow: 'hidden',
  backgroundColor: 'white',
  borderRadius: 8,
  boxShadow:
    '0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)'
})

const StyledViewport = styled(Select.Viewport)({
  padding: 6
})
